<!-- 由 suu 创建于 2021-08-18 星期三 -->
<template>
  <div class="DetailDesc">
    <!-- 头部 -->
    <van-swipe
      class="dd-swipe animate__animated animate__fadeIn animate__slow"
      :autoplay="0"
      :loop="false"
      :show-indicators="false"
      @change="onSwipeChange"
      ref="swipe"
    >
      <van-swipe-item
        v-for="(item, index) in coachImg"
        :key="index"
        @click="showImagePreview(index)"
      >
        <!-- 头像 -->
        <img class="sw-head" :src="item.img || item.image" alt="" />
        <!-- 背景 -->
        <!-- 粉色背景 -->
        <img
          class="sw-bg-pink"
          v-if="item.type == 2"
          src="https://cdnvue.gymcity.com.cn/uploads/25coach-img-bg-pink"
          alt=""
        />
        <!-- 默认蒙版 -->
        <img
          class="sw-bg"
          v-else
          src="https://cdnvue.gymcity.com.cn/uploads/25coach-img-bg?v=1"
          alt=""
        />
        <!-- logo -->
        <img
          v-if="index == 0"
          class="sw-logo"
          src="https://cdnvue.gymcity.com.cn/uploads/pub-white-logo"
          alt=""
        />
      </van-swipe-item>
      <van-swipe-item
        style="background-color: #fff"
        v-if="showInfo && showInfo.btw_id && isApp"
      >
        <div class="dd-swipe-last">
          <van-icon class="last-icon" name="arrow-left" />
          <div class="last-text"> 左滑 去 Ta 的 圈子 </div>
        </div>
      </van-swipe-item>

      <template v-slot:indicator v-if="coachImg.length > 1">
        <div class="dd-swipe-indi">
          <span class="indi-index-num">{{ swipeIndex + 1 }}</span>
          <span class="indi-index-slash">/</span>
          <span class="indi-index-total">{{ coachImg.length }}</span>
        </div>
      </template>
    </van-swipe>
    <!--  -->
    <!-- 教练信息 -->
    <div class="dd-info">
      <!--当有教练性格的时候-->
      <div v-if="tagName2" class="info-top-type">
        <div class="it-top">
          <div class="itt-name">{{ detailData.name }}</div>
          <div class="itt-character">
            <span class="ittc-label">训练风格</span>
            <van-icon class="ittc-star" name="star" />
            <span class="ittc-value"> {{ tagName2 }}</span>
          </div>
        </div>
        <div class="it-shop">{{ detailData.shop_name }}</div>
      </div>
      <div class="info-top" v-else>
        <div class="top-name">{{ detailData.name }}</div>
        <div class="top-shop">{{ detailData.shop_name }}</div>
      </div>

      <!-- 评价标签 -->
      <div class="info-tag" v-if="showInfo && showInfo.new_tag"
        ><img
          class="tag-icon"
          src="https://cdnvue.gymcity.com.cn/uploads/25coach-tag-icon-dz"
          alt=""
        />
        <div>{{ showInfo.new_tag }}</div>
      </div>
      <!-- 擅长标签 -->
      <div
        class="info-wrap"
        v-if="showInfo && showInfo.tag_list && showInfo.tag_list.length"
      >
        <div class="wrap-title">擅长</div>
        <div class="wrap-tags">
          <div
            class="tag-item"
            :class="{ 'tag-item-one': showInfo.tag_list.length == 1 }"
            v-for="(item, index) in showInfo.tag_list"
            :key="index"
          >
            <img
              class="i-line"
              v-if="index != 0"
              src="https://cdnvue.gymcity.com.cn/uploads/25coach-appo-line"
              alt=""
            />
            <img
              class="i-icon"
              :src="
                item.tag_icon ||
                'https://cdnvue.gymcity.com.cn/uploads/25coach-approve-icon-normal'
              "
              alt=""
            />
            <div class="i-text">{{ item.tag_name }}</div>
          </div>
        </div>
      </div>
      <!-- 证书 -->
      <div
        class="info-wrap info-wrap-approve"
        v-if="showInfo && showInfo.approve && showInfo.approve.length"
      >
        <div class="wrap-title">证书</div>
        <div
          class="wrap-approve"
          :class="{ 'wrap-approve-hide': !showAppMore }"
          :style="{ maxHeight: curMaxHeight }"
        >
          <div
            class="approve-left"
            @click="showAppMore = showAppMore ? showAppMore : !showAppMore"
          >
            <div
              class="approve-item"
              v-for="(item, index) in detailData.approve"
              :key="index"
            >
              <img
                class="i-icon"
                src="https://cdnvue.gymcity.com.cn/uploads/25coach-icon-zs"
                alt=""
              />
              <span>{{ item }}</span>
            </div>
          </div>
          <div
            class="approve-right"
            v-if="detailData.approve.length > 1"
            @click="showAppMore = !showAppMore"
            ><span v-if="showAppMore">收起</span
            ><span v-else>{{ detailData.approve.length }}项</span>
            <van-icon
              class="r-icon"
              :class="{ 'r-icon-more': showAppMore }"
              :name="'arrow-down'"
          /></div>
        </div>
      </div>
    </div>
    <PreviewImageSave
      v-if="showPreview"
      :previewImages="previewImages"
      :showPreviewIndex="showPreviewIndex"
      :btwId="isApp ? showInfo.btw_id : ''"
      @close="showPreview = false"
    />
  </div>
</template>

<script>
import GymPopup from '@/components/GymPopup'
import DoubleCodePop from './DoubleCodePop.vue'
import PreviewImageSave from '@/components/PreviewImageSave.vue'
export default {
  name: 'DetailDesc',

  components: {
    GymPopup,
    DoubleCodePop,
    PreviewImageSave
  },

  props: {
    detailData: {},
    showInfo: {}
  },

  data() {
    return {
      showAppMore: false, // 教练证书是否展示更多
      swipeIndex: 0,
      showPreview: false,
      showPreviewIndex: 0
    }
  },

  computed: {
    isApp() {
      return this.$betterwe.isApp()
    },
    curMaxHeight() {
      if (this.detailData.approve && this.detailData.approve.length > 1) {
        console.log('clientWidth', document.documentElement.clientWidth)
        return (
          (document.documentElement.clientWidth / 375) *
            22 *
            this.detailData.approve.length +
          'vw'
        )
      }
      return ''
    },
    coachImg() {
      let arr = []
      if (this.showInfo) {
        if (this.showInfo.app_img) {
          arr = [
            {
              img:
                this.showInfo.app_img +
                '?x-oss-process=image/resize,m_fill,h_750,w_750',
              type: 2
            }
          ]
        } else {
          arr = [
            {
              img:
                this.showInfo.image +
                '?x-oss-process=image/resize,m_fill,h_750,w_750',
              type: 1
            }
          ]
        }
        if (
          this.showInfo.coach_img_list &&
          this.showInfo.coach_img_list.length
        ) {
          arr = arr.concat(this.showInfo.coach_img_list)
        }
      }
      return arr
    },
    previewImages() {
      let arr = this.coachImg.map((item) => item.img || item.image)
      // 第一张用老图
      arr[0] = this.showInfo.image
      return arr
    },
    tagName2() {
      if (!this.showInfo) {
        return ''
      }
      const tag_list2 = this.showInfo.tag_list2 || []
      if (tag_list2.length > 0) {
        return tag_list2
          .map((item) => {
            return item.tag_name
          })
          .join('/')
      }
      return ''
    }
  },

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    // 轮播图切换
    onSwipeChange(index) {
      if (index >= this.coachImg.length) {
        this.$http.get('member/index?a=shareLogPush', {
          from: `教练主页-去圈子`,
          from_id: 250326
        })
        this.$betterwe.jumpRoute(`/gymCoachDetails?id=${this.showInfo.btw_id}`)
        this.$refs.swipe.swipeTo(this.coachImg.length - 1)
        return
      }
      this.swipeIndex = index
    },
    // 显示图片预览
    showImagePreview(index) {
      this.$http.get('member/index?a=shareLogPush', {
        from: `教练主页-点击查看大图`,
        from_id: 250326
      })
      this.showPreview = true
      this.showPreviewIndex = index
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.DetailDesc {
  width: 100%;
  box-sizing: border-box;
  padding-top: vw(294);
  padding-bottom: vw(10);
  background-color: rgb(255, 241, 246);
  position: relative;
  // z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 300;
  .dd-swipe {
    width: 100%;
    height: vw(510);
    box-sizing: border-box;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 0;
    .dd-swipe-indi {
      width: 40px;
      height: 20px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 1px;
      font-size: 13px;
      font-weight: 300;
      position: absolute;
      top: 264px;
      right: 20px;
      background: rgba($color: #050b27, $alpha: 0.8);
      border-radius: 12px;
      color: rgba($color: #fff, $alpha: 0.5);
      z-index: 2;
      span {
      }
      .indi-index-slash {
        font-size: 8px;
        margin: 0 1px;
      }
      .indi-index-num {
        color: #fff;
        font-weight: 600;
      }
    }
    .sw-head {
      width: 100%;
      // height: vw(510);
      box-sizing: border-box;
      // object-fit: cover;
      position: relative;
      z-index: 1;
    }
    .sw-bg {
      width: 100%;
      box-sizing: border-box;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
    }
    .sw-bg-pink {
      width: 100%;
      box-sizing: border-box;
      width: 100%;
      box-sizing: border-box;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 0;
    }
    .sw-logo {
      width: vw(169);
      position: absolute;
      top: vw(265);
      left: vw(20);
      z-index: 3;
    }
    .dd-swipe-last {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 400;
      font-size: vw(12);
      color: #050b27;
      position: absolute;
      top: vw(110);
      left: vw(10);
      z-index: 4;
      .last-text {
        width: vw(14);
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
      .last-icon {
        font-size: vw(10);
        opacity: 0.5;
        margin-right: vw(3);
        padding: vw(2);
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid rgba($color: #050b27, $alpha: 0.5);
        border-radius: 50%;
      }
    }
  }
  .dd-info {
    width: vw(355);
    box-sizing: border-box;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.7) 0%,
      #ffffff 100%
    );
    border-radius: 8px;
    backdrop-filter: blur(10px);
    padding: vw(10) vw(20);
    padding-bottom: vw(15);
    position: relative;
    .info-top {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: baseline;
      flex-wrap: nowrap;
      position: relative;
      .top-name {
        // max-width: 100px;
        // white-space: nowrap;
        // text-overflow: ellipsis;
        // overflow: hidden;
        font-size: vw(22);
        font-weight: 600;
        color: #050b27;
        margin-right: vw(10);
        line-height: vw(33);
      }
      .top-shop {
        flex: 1;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: vw(15);
        font-weight: 300;
        color: #050b27;
        // margin-right: vw(8);
        // color: rgba($color: #050b27, $alpha: 0.8);
      }
    }
    .info-top-type {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      position: relative;
      .it-top {
        width: 100%;
        display: flex;
        align-items: center;
        margin-bottom: vw(3);
        .itt-name {
          font-size: vw(22);
          font-weight: 600;
          color: #050b27;
          margin-right: vw(10);
          line-height: vw(33);
          flex-shrink: 0;
        }
        .itt-character {
          display: flex;
          align-items: center;
          //min-width: vw(140);
          box-sizing: border-box;
          background: #ffedd3;
          padding: vw(4) vw(10);
          border-radius: vw(11);
          font-size: vw(10);
          color: rgba($color: #050b27, $alpha: 0.6);
          line-height: vw(14);
          .ittc-label {
            flex-shrink: 0;
            font-size: vw(10);
            font-weight: 400;
            color: #704b1b;
          }
          .ittc-star {
            color: #d0a76e;
            margin-left: vw(4);
            margin-right: vw(4);
            font-size: vw(8);
          }
          .ittc-value {
            font-weight: 600;
            color: #704b1b;
            //flex: 1;
            //white-space: nowrap;
            //text-overflow: ellipsis;
            //overflow: hidden;
          }
        }
      }
      .it-shop {
        flex: 1;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: vw(12);
        line-height: vw(17);
        font-weight: 400;
        color: #050b27;
        // margin-right: vw(8);
        // color: rgba($color: #050b27, $alpha: 0.8);
      }
    }
    .info-tag {
      padding: vw(3) vw(7) vw(3) vw(10);
      // padding-left: vw(12);
      box-sizing: border-box;
      height: 20px;
      background: #fff;
      border-radius: 0px 8px 0px 8px;
      font-weight: 400;
      font-size: 10px;
      color: rgba(5, 11, 39, 1);
      line-height: 14px;
      position: relative;
      top: -1px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 0;
      right: 0;
      .tag-icon {
        filter: brightness(0.08) saturate(15) hue-rotate(220deg);
        width: 10px;
        height: 10px;
        margin-right: 4px;
        position: relative;
      }
    }
    .info-wrap {
      width: 100%;
      box-sizing: border-box;
      margin-top: vw(14);
      .wrap-title {
        width: 100%;
        box-sizing: border-box;
        height: vw(20);
        display: flex;
        align-items: center;
        background-color: rgba($color: #050b27, $alpha: 0.05);
        border-radius: vw(2);
        padding: 0 vw(10);
        font-size: vw(13);
        font-weight: 600;
        color: #050b27;
      }
      .wrap-tags {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        margin-top: vw(10);
        .tag-item {
          // width: vw(82);
          flex: 1;
          box-sizing: border-box;
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          color: #050b27;
          // & + .tag-item::before {
          //   content: '........';
          //   letter-spacing: vw(1);
          //   // border-left: dashed 1px rgba($color: #050b27, $alpha: 0.25);
          //   position: absolute;
          //   left: vw(-16);
          //   color: rgba($color: #050b27, $alpha: 0.5);
          //   top: 50%;
          //   transform: translateY(-60%) rotate(90deg);
          // }
          .i-line {
            width: vw(1);
            position: absolute;
            left: 0;
            top: vw(4);
            transform: translate(-50%, 0);
          }
          .i-icon {
            width: vw(24);
            height: vw(24);
            display: block;
          }
          .i-text {
            opacity: 0.8;
            font-size: vw(12);
            margin-top: vw(2);
            line-height: vw(22);
          }
        }
        .tag-item-one {
          width: vw(78.75);
        }
      }
      .wrap-approve {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        align-items: flex-start;
        padding-left: vw(10);
        margin-top: vw(6);
        max-height: vw(110);
        transition: all ease-in 0.3s;
        overflow: hidden;
        position: relative;
        .approve-left {
          flex: 1;
          .approve-item {
            width: 100%;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            font-weight: 300;
            font-size: vw(12);
            color: rgba($color: #050b27, $alpha: 0.8);
            line-height: vw(22);
            display: flex;
            align-items: center;
            & + .approve-item {
              margin-top: vw(8);
            }
            .i-icon {
              width: vw(22);
              margin-right: vw(7);
            }
            span {
              width: vw(225);
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
          }
        }
        .approve-right {
          display: flex;
          align-items: center;
          justify-content: center;
          color: #050b27;
          font-weight: 300;
          font-size: vw(12);
          height: vw(22);
          line-height: vw(22);
          position: absolute;
          right: 0;
          bottom: vw(-1);
          // transition: all ease-in 0.3s;
          .r-icon {
            font-weight: 400;
            margin-left: vw(4);
            font-size: vw(8);
            transition: transform 0.3s;
          }
          .r-icon-more {
            transform: rotate(180deg);
          }
        }
      }
      .wrap-approve-hide {
        // 根据最大高度来生产过渡动画
        max-height: vw(22) !important;
        transition: all ease-out 0.2s !important;
      }
    }
    .info-wrap-approve {
      margin-top: vw(8);
    }
  }
}
</style>
